<div class="attendance-root">

  <!-- DERS KARTI -->
  <div class="lesson-card">

    <div class="lesson-header">
      <div class="lesson-title">
        <i class="fa-solid fa-book-open"></i>
        <span>{{ lessonName }}</span>
      </div>

      <!-- INFO / ONBOARDING -->
      <button class="info-btn" (click)="openOnboarding()" aria-label="İzinler ve Bilgilendirme">
        <i class="fa-solid fa-circle-info"></i>
      </button>
    </div>

    <div class="lesson-meta">
      <div class="meta-item">
        <i class="fa-solid fa-home"></i>
        <span>{{lessonSalaon}}</span>

      </div>

      <div class="meta-item">
        <i class="fa-solid fa-calendar-day"></i>
        <span>{{ lessonGun }}</span>
        <i class="fa-solid fa-clock"></i>
        <span>{{ lessonStartTime }} – {{ lessonEndTime }}</span>
      </div>
    </div>


    <div *ngIf="attendanceCache.ogrenciDersSaatleri.length" class="attendance-panel">

      <div class="attendance-progress">
        <div class="attendance-progress-bar" [style.width.%]="getAttendancePercentFromCache()">
        </div>
      </div>

      <div class="attendance-percent">
        %{{ getAttendancePercentFromCache() }} Katılım
      </div>

      <!-- DERS SAATLERİ -->
      <div class="attendance-slots justify-content-end">
        <div *ngFor="let slot of attendanceCache.ogrenciDersSaatleri" class="attendance-slot"
          [ngClass]="getSlotClass(slot, attendanceCache)">
          {{ slot.slotNumber }}. Saat
        </div>

      </div>

    </div>

    <div class="lesson-slot">
      <i class="fa-solid fa-hourglass-half"></i>
      Yoklama Saati: {{ currentSlot }}. Ders Saati
    </div>

  </div>
  <div class="attendance-not-started" *ngIf="!butonGoster">

    <div class="status-badge">
      <i class="fa-solid fa-hourglass-start"></i>
      Yoklama Henüz Başlamadı
    </div>

    <p class="status-text">
      Ders yoklaması henüz aktif edilmedi.
      Lütfen ders saati geldiğinde tekrar deneyin.
    </p>

    <button class="btn btn-outline-primary retry-btn" (click)="goBack()">
      <i class="fa-solid fa-rotate-right"></i>
      Tekrar Dene
    </button>

  </div>

  <!-- TIMER -->
  <div class="timer-card">
    <div class="timer-title">
      <i class="fa-solid fa-clock"></i>
      Kalan Süre
    </div>
    <div class="timer-time">{{ formatTime() }}</div>
  </div>

  <!-- AKSİYONLAR -->
  <div class="action-area" *ngIf="!attendanceSuccess">

    <button class="action-btn primary" *ngIf="konumKontrolAktif && !locationAllowed" (click)="checkLocation()">
      <i class="fa-solid fa-location-dot"></i>
      Konumu Doğrula
    </button>
<div class="camera-wrapper" *ngIf="cameraOpen">

  <video
    #video
    autoplay
    playsinline
    muted
  ></video>

  <canvas #canvas style="display: none;"></canvas>

</div>
    <button class="action-btn info" *ngIf="qrUretAktif && !cameraPermissionDenied"
      (click)="openCamera()">
      <i class="fa-solid fa-qrcode"></i>
      QR Kod Oku
    </button>

    <button class="action-btn success" *ngIf="!qrUretAktif && (!konumKontrolAktif || locationAllowed) && butonGoster"
      (click)="handleAttendanceClick()">
      <i class="fa-solid fa-check-circle"></i>
      Buradayım
    </button>

  </div>

  <div class="card p-3 info-card" *ngIf="formatTime()!=='00:00'">


    <div class="table-responsive">
      <table class="table table-bordered align-middle text-center mb-0">
        <thead class="table-light">
          <tr>
            <th style="min-width: 150px;">Öğrenci</th>
            <th *ngFor="let lbl of generateSlotLabels(); let i = index">
              {{ i+1 }}. Saat
            </th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let s of students">
            <td class="text-start">
              <div class="fw-bold">{{ s.studentName ?? '' }} {{ s.studentSurName ?? '' }}</div>
              <div class="small text-muted">{{ s.studentId }}</div>
            </td>

            <td *ngFor="let slotIndex of generateSlotLabels(); let si = index">
              <ng-container *ngFor="let a of s.attendance">
                <ng-container *ngIf="a.slotNumber === si+1 ">
                  <ng-container *ngIf="a.katildiMi; else notJoined">
                    <i *ngIf="a.konumDisi" class="fa-solid fa-location-crosshairs text-danger"
                      title="Konum dışı katılım"></i>
                    <i *ngIf="!a.konumDisi" class="fa-solid fa-check-circle text-success" title="Katıldı"></i>
                  </ng-container>
                  <ng-template #notJoined>
                    <i class="fa-solid fa-xmark-circle text-secondary" title="Katılmadı"></i>
                  </ng-template>
                </ng-container>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>

<!-- ================= ONBOARDING MODAL ================= -->
<div class="onboarding-backdrop" *ngIf="showOnboarding">
  <div class="onboarding-modal">

    <h2>Yoklamaya Başlamadan Önce</h2>

    <!-- 🔥 DİNAMİK ALERT -->
    <div class="perm-alert">

      <span *ngIf="konumKontrolAktif && !locationAllowed" class="badge warn">
        📍 Konum izni gerekli
      </span>

      <span *ngIf="qrUretAktif && cameraPermissionDenied" class="badge warn">
        📷 Kamera izni gerekli
      </span>

      <span *ngIf="locationAllowed && !cameraPermissionDenied" class="badge ok">
        ✔ Tüm izinler hazır
      </span>

    </div>

    <p class="subtitle">
      Aşağıdaki izinler ders yoklaması için gereklidir
    </p>

    <!-- KONUM -->
    <div class="perm-item">
      <div>
        <b>📍 Konum</b>
        <small>Ders alanında olduğunu doğrulamak için</small>
        <span class="status success" *ngIf="locationAllowed">✔ Verildi</span>
      </div>

      <button class="btn outline"
              [disabled]="locationAllowed || !konumKontrolAktif"
              (click)="requestLocationPermission()">
        {{ locationAllowed ? 'Verildi' : 'İzin Ver' }}
      </button>
    </div>

    <!-- KAMERA -->
    <div class="perm-item">
      <div>
        <b>📷 Kamera</b>
        <small>QR kodu okumak için</small>
        <span class="status success" *ngIf="!cameraPermissionDenied">✔ Verildi</span>
      </div>

      <button class="btn outline"
              [disabled]="!qrUretAktif || !cameraPermissionDenied === false"
              (click)="requestCameraPermission()">
        İzin Ver
      </button>
    </div>

    <!-- DEVAM -->
    <button class="btn primary full"
            (click)="closeOnboarding()">
      Devam Et
    </button>

  </div>

</div>
